export default "__VITE_ASSET__CP8i2G6D__"